import React from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Img from "../../assets/logo.png";
import Img1 from "../../assets/pattern.jpg";
import Footer from "./Footer";
const Auth = () => {
  const [username, setUsername] = React.useState("");
  const [password, setPassword] = React.useState("");

  const notify = (text) =>
    toast(text, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });

  const handleSubmit = (e) => {
    e.preventDefault();

    try {
      fetch(process.env.REACT_APP_SERVER_URL + "/admin/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          username,
          password,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if (data.success) {
            localStorage.setItem("token", data.token);
            localStorage.setItem("user", JSON.stringify(data.user));
            window.location.href = "/admin/dashboard";
          } else {
            notify(data.message);
          }
        });
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div>
      <section
        style={{
          backgroundImage: `url(${Img1})`,
          backgroundSize: "contain",
        }}
      >
        <div className="">
          <ToastContainer className="mt-20" />
        </div>
        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0 ">
          <div className="text-center w-full rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 bg-gray-400 dark:border-gray-700">
            <div className="p-6 space-y-4 md:space-y-6 sm:p-8 rounded-t-lg bg-gradient-to-b from-red-200 via-red-500 to-red-500">
              <a
                href="https://go-green-10.vercel.app/"
                className="items-center text-3xl text-center font-semibold text-gray-900"
              >
                <img className="w-20 h-20 m-auto" src={Img} alt="logo" />
                <span className="mr-2">Go</span>
                <span className="text-green-600 text-bold">Green Admin</span>
              </a>
            </div>
          </div>
          <div className="w-full rounded-b-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0 bg-gray-400 dark:border-gray-700">
            <div className="flex flex-col p-6 space-y-4 md:space-y-6 sm:p-8">
              <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl dark:text-white text-center">
                Admin Account
              </h1>
              <div>
                <label
                  htmlFor="username"
                  className="block mb-2 font-bold text-sm  text-gray-900 dark:text-white"
                >
                  {" "}
                  Username
                </label>
                <input
                  type="text"
                  name="username"
                  id="username"
                  className="user bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="Admin"
                  required={true}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              <div>
                <label
                  htmlFor="password"
                  className="block mb-2 font-bold text-sm  text-gray-900 dark:text-white"
                >
                  Password
                </label>
                <input
                  type="password"
                  name="password"
                  id="password"
                  placeholder="********"
                  className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-3 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  required={true}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>
              <button
                type="submit"
                onClick={(e) => handleSubmit(e)}
                className="w-full text-white bg-red-600 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-3 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
              >
                Signin
              </button>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Auth;
